export const EstimateStatusList = [
    {
        icon: 'infinite-outline',
        status: 'All',
        loadStatus: 'Drafts'
    },
    {
        icon: 'contrast-outline',
        status: 'Trip Estimate',
        loadStatus: 'Estimated'
    },
    {
        icon: 'checkmark-done-outline',
        status: 'Activated',
        loadStatus: 'ActiveEstimate',
    },
    {
        icon: 'thumbs-down-outline',
        status: 'Expired',
        loadStatus: 'ExpiredEstimated',
    },
    {
        icon: 'close-circle-outline',
        status: 'Cancelled',
        loadStatus: 'Tripcancelled',
    },
];
export const CharterEstimateStatusList = [
    {
        icon: 'infinite-outline',
        status: 'All',
        loadStatus: 'Drafts'
    },
    {
        icon: 'contrast-outline',
        status: 'Estimates',
        loadStatus: 'CharterEstimates'
    },
    {
        icon: 'pricetag-outline',
        status: 'Quotes',
        loadStatus: 'CharterQuote'
    },
    {
        icon: 'checkmark-done-outline',
        status: 'Activated',
        loadStatus: 'ActiveEstimate',
    },
    {
        icon: 'close-circle-outline',
        status: 'Expired',
        loadStatus: 'ExpiredEstimated',
    },
]

export enum TripStatus {
  Drafts = 'Drafts',
  Estimated = 'Estimated',
  Actived = 'ActiveEstimate',
  Expired = 'ExpiredEstimated',
  Cancelled = 'Tripcancelled',
}

